// removed by extract-text-webpack-plugin
module.exports = {"dialog":"app-components-receipt-transactions-ResendEmailModal-__resendEmailModal___36wQ1","footer":"app-components-receipt-transactions-ResendEmailModal-__resendEmailModal___1vBtd"};


//////////////////
// WEBPACK FOOTER
// ./app/components/receipt/transactions/ResendEmailModal/resendEmailModal.css
// module id = 2025
// module chunks = 0